import * as React from 'react'
import { SVGProps } from 'react'

const SvgRedirectArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#redirectArrowIcon_svg__a)'>
      <path
        d='M9 5h4.83V3.412A2 2 0 0 1 17.244 2l5.88 5.88a3 3 0 0 1 0 4.241L17.244 18a2 2 0 0 1-3.414-1.415V15H8a6.006 6.006 0 0 0-6 6 1 1 0 1 1-2 0v-7a9.01 9.01 0 0 1 9-9Z'
        fill='#fff'
      />
    </g>
    <defs>
      <clipPath id='redirectArrowIcon_svg__a'>
        <path fill='#fff' transform='matrix(-1 0 0 1 24 0)' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgRedirectArrowIcon
